"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosLoadingInterceptor = void 0;
class AxiosLoadingInterceptor {
    constructor(axiosInstance, onRequestStart, onRequestEnd) {
        this.axiosInstance = axiosInstance;
        this.onRequestStart = onRequestStart;
        this.onRequestEnd = onRequestEnd;
    }
    setupInterceptor() {
        this.addRequestInterceptor();
        this.addResponseInterceptor();
    }
    addRequestInterceptor() {
        this.axiosInstance.registerRequestInterceptor((config) => {
            this.onRequestStart(config);
            return config;
        });
    }
    addResponseInterceptor() {
        this.axiosInstance.registerResponseInterceptor((response) => {
            this.onRequestEnd(response);
            return response;
        }, (error) => {
            this.onRequestEnd(error);
        });
    }
}
exports.AxiosLoadingInterceptor = AxiosLoadingInterceptor;
//# sourceMappingURL=AxiosLoadingInterceptor.js.map